import { render, staticRenderFns } from "./pageClosed.vue?vue&type=template&id=41ad1d30&scoped=true&"
import script from "./pageClosed.vue?vue&type=script&lang=js&"
export * from "./pageClosed.vue?vue&type=script&lang=js&"
import style0 from "./pageClosed.vue?vue&type=style&index=0&id=41ad1d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad1d30",
  null
  
)

export default component.exports